$(function(){
  var swiper = new Swiper('.swiper-container01', {
    navigation: { 
      nextEl: '.swiper-button-next01',
      prevEl: '.swiper-button-prev01',
    },
    pagination: {
    el: '.swiper-pagination01',
    clickable: true,
  },
    loop: true,
    observer: true,
		observeParents: true,
    /*speed: 5000,*/ // ループの時間
    /*allowTouchMove: false,*/ // スワイプ無効
  /*autoplay: {*/
    /*delay: 0,*/ // 途切れなくループ
  /*},*/
    /*disabledClass: '.swiper-button-disabled',*/
    slidesPerView: 1, // 一度に表示する枚数
    /*centeredSlides: true, */// アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 3,
				spaceBetween: 60,
			}
		}
	});
  });

  $(function(){
  var swiper = new Swiper('.swiper-container01.pc-2column', {
    navigation: { 
      nextEl: '.swiper-button-next01',
      prevEl: '.swiper-button-prev01',
    },
    pagination: {
    el: '.swiper-pagination01',
    clickable: true,
  },
    loop: true,
    observer: true,
		observeParents: true,
    slidesPerView: 1, // 一度に表示する枚数
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
        slidesPerView: 2,
				spaceBetween: 120,
			}
		}
	});
  });

$(function(){
  var swiper = new Swiper('.swiper-container02', {
    navigation: { 
      nextEl: '.swiper-button-next02',
      prevEl: '.swiper-button-prev02',
    },
    pagination: {
    el: '.swiper-pagination02',
    clickable: true,
  },
    loop: true,
    observer: true,
		observeParents: true,
    /*speed: 5000,*/ // ループの時間
    /*allowTouchMove: false,*/ // スワイプ無効
  /*autoplay: {*/
    /*delay: 0,*/ // 途切れなくループ
  /*},*/
    /*disabledClass: '.swiper-button-disabled',*/
    slidesPerView: 1, // 一度に表示する枚数
    /*centeredSlides: true, */// アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 3,
				spaceBetween: 60,
			}
		}
	});
  });